import * as React from 'react';
import { useState } from 'react';
import * as jose from 'jose';
import environment from '../../../environment/env.dev';
import { DevUserClaims } from '../../utils/interfaces';

const secret = new TextEncoder().encode('[B@3b07d329');
const alg = 'HS512';

interface UserClaims {
    email: string;
    aud: string;
    client_id: string;
    authorization_group: string[];
    entitlement_group: string[];
    family_name: string;
    given_name: string;
    sub: string;
}

export const envDevUserClaims: DevUserClaims = {
    email: environment.EMAIL,
    family_name: environment.FAMILIY_NAME,
    given_name: environment.GIVEN_NAME,
    sub: environment.SUB,
    entitlement_group: environment.ENTITLEMENT_GROUP,
    aud: environment.AUD,
    client_id: environment.CLIENT_ID,
};

export const initUserClaims: UserClaims = {
    aud: environment.AUD,
    authorization_group: environment.AUTHORIZATION_GROUP,
    client_id: environment.CLIENT_ID,
    email: environment.EMAIL,
    entitlement_group: environment.ENTITLEMENT_GROUP,
    family_name: environment.FAMILIY_NAME,
    given_name: environment.GIVEN_NAME,
    sub: environment.SUB,
};

export interface JwtCreationContext {
    createFakeJwt: () => Promise<string>;
    setClaims: (userClaims: DevUserClaims) => void;
    claims: UserClaims;
}

const initState: JwtCreationContext = {
    createFakeJwt: () => {
        return new Promise(() => {});
    },
    setClaims: () => {},
    claims: initUserClaims,
};

const jwtCreationContext = React.createContext<JwtCreationContext>(initState);

export function JwtCreationProvider(props: Readonly<{ children: React.ReactNode }>): React.ReactElement {
    const [userClaims, setUserClaims] = useState<UserClaims>(initUserClaims);

    const setClaims = (userClaims: DevUserClaims) => {
        setUserClaims({
            authorization_group: environment.AUTHORIZATION_GROUP,
            ...userClaims,
        });
    };

    const createFakeJwt = async () => {
        const claims = {
            aud: userClaims.aud,
            authorization_group: userClaims.authorization_group,
            client_id: userClaims.client_id,
            email: userClaims.email,
            entitlement_group: [...userClaims.entitlement_group],
            family_name: userClaims.family_name,
            given_name: userClaims.given_name,
            sub: userClaims.sub,
        };

        return await new jose.SignJWT(claims)
            .setProtectedHeader({ alg })
            .setIssuer(environment.ISSUER)
            .setExpirationTime(environment.EXPIRATION_TIME)
            .sign(secret);
    };

    return (
        <jwtCreationContext.Provider value={{ createFakeJwt: createFakeJwt, setClaims: setClaims, claims: userClaims }}>
            {props.children}
        </jwtCreationContext.Provider>
    );
}

export function useJwtCreationContext() {
    return React.useContext(jwtCreationContext);
}
